import { BiDesktop, BiBookOpen, BiUserCheck } from "react-icons/bi";
import { LuNotebookPen } from "react-icons/lu";
import { RiWhatsappLine } from "react-icons/ri";

import LegalPageLayout from "../../components/elements/legal-page-layout";
import "./index-privacy-policy.css";

export function PrivacyPolicy(props) {

    const toc = [
  { id: "dados", label: "Dados coletados" },
  { id: "finalidade", label: "Finalidades" },
  { id: "compartilhamento", label: "Compartilhamento" },
  { id: "cookies", label: "Cookies" },
  { id: "direitos", label: "Direitos do titular" },
  { id: "seguranca", label: "Segurança" },
  { id: "contato", label: "Contato" },
];

  return (
    <>
    <LegalPageLayout
      eyebrow="Privacidade e proteção de dados"
      title="Política de Privacidade"
      description="Entenda como o Escrita & Prática trata dados pessoais durante a navegação e a utilização dos serviços."
      toc={toc}
    >
      <div className="ep-note">
        <p>
          <strong>Última atualização:</strong> 08 de setembro de 2026.
          Este texto é um modelo informativo e deve ser revisado juridicamente
          antes da publicação definitiva.
        </p>
      </div>

      <h2 id="dados">1. Dados coletados</h2>
      <p>
        O Escrita & Prática poderá coletar dados fornecidos voluntariamente
        pelo usuário, como nome, e-mail, telefone e informações necessárias
        para atendimento, contratação e prestação dos serviços educacionais.
      </p>

      <h2 id="finalidade">2. Finalidades do tratamento</h2>
      <ul>
        <li>Realizar atendimento e comunicação com o aluno;</li>
        <li>Prestar e acompanhar os serviços contratados;</li>
        <li>Agendar aulas, mentorias e atividades;</li>
        <li>Processar pagamentos por provedores apropriados;</li>
        <li>Melhorar a experiência e segurança do site;</li>
        <li>Cumprir obrigações legais aplicáveis.</li>
      </ul>

      <h2 id="compartilhamento">3. Compartilhamento de dados</h2>
      <p>
        Os dados poderão ser compartilhados quando necessário para execução
        dos serviços, processamento de pagamentos, funcionamento de
        ferramentas tecnológicas ou cumprimento de obrigação legal. O
        Escrita & Prática não pretende comercializar dados pessoais dos
        usuários.
      </p>

      <h2 id="cookies">4. Cookies</h2>
      <p>
        O site poderá utilizar cookies essenciais e, quando aplicável,
        recursos de análise ou serviços de terceiros. O usuário poderá
        controlar cookies por meio das configurações do navegador.
      </p>

      <h2 id="direitos">5. Direitos do titular</h2>
      <p>
        Nos termos da legislação aplicável, especialmente da LGPD, o titular
        poderá exercer os direitos previstos em lei, incluindo solicitações
        relacionadas a acesso, correção, atualização e eliminação quando
        cabível.
      </p>

      <h2 id="seguranca">6. Segurança e retenção</h2>
      <p>
        São adotadas medidas técnicas e administrativas razoáveis para
        proteger os dados contra acessos não autorizados, perda, alteração
        ou divulgação indevida. Os dados serão mantidos pelo período
        necessário às finalidades informadas ou ao cumprimento de obrigações
        legais.
      </p>

      <h2>7. Alterações da política</h2>
      <p>
        Esta política poderá ser atualizada para refletir mudanças legais,
        técnicas ou operacionais. A versão vigente será disponibilizada nesta
        página.
      </p>

      <h2 id="contato">8. Contato</h2>
      <p>
        Para dúvidas ou solicitações relacionadas à privacidade, utilize o
        canal oficial de atendimento informado pelo Escrita & Prática.
      </p>
    </LegalPageLayout>
    </>
  );
}

export default PrivacyPolicy;